import React from 'react'
import { Text } from '@adc/ui-adc'
import { Maybe } from '@adc/sdk/types'
import { formatMoneyWithNumeral } from 'common/utils/formatters'
import { ZERO_DOLLARS } from 'common/components/bidBanner/constants'

type SalesDepositProps = {
  salesDeposit?: Maybe<number>
  className?: string
}

const SalesDeposit = ({ salesDeposit, className }: SalesDepositProps) => {
  if (!salesDeposit) return null
  return (
    <div className={className}>
      <Text
        className='u-mr-1'
        color='gray'
        content='Sales Deposit'
        data-elm-id='sales_deposit_label'
        size='tiny'
      />
      <Text
        color='gray'
        content={formatMoneyWithNumeral(salesDeposit, ZERO_DOLLARS)}
        data-elm-id='sales_deposit_value'
        size='tiny'
        weight='heavy'
      />
    </div>
  )
}

export default SalesDeposit
